/**
 * Test IDs for QA automation.
 */
export const testIds = {
  tractorDetailsDelete: "tractor-details-delete",
  tractorDetailsEdit: "tractor-details-edit",
  tractorDetailsOpen: "tractor-details-open",
  tractorDetailsClose: "tractor-details-close",
} as const;
